import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import careImg from "@/assets/csr/care-work.png";
import useCare from "@/hooks/useCare";
import Link from "next/link";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";
import CustomSourceflowText from "@/components/Shared/CustomSourceflowText";

export default function CareWork({ title, dif, path }) {
  const locale = useLocale();
  const care = useCare();

  return (
    <div className="container pt-10 lg:pt-24 pb-20 md:pb-[148px]">
      <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-purple max-w-[679px] 3xl:max-w-none">
        <CustomSourceFlowText
          title={title}
          path={`dynamic1.${path}.header2`}
          locale={locale}
        />
        {dif && <span className="text-pink">.</span>}
      </h2>
      <div className="flex justify-between pt-14 gap-10 flex-col md:flex-row">
        <div className="3xl:w-[80%]">
          <SourceFlowImage
            src={careImg ?? ""}
            size="607x400"
            alt="care work image"
            className="xmax-w-[607px] w-full max-h-[400px] md:max-h-[781px] h-full object-cover 3xl:max-w-none"
          />
        </div>
        <div className="text-purple text-lg sm:text-xl/8 max-w-[591px]">
          <span className="max-w-[540px] block">
            <CustomSourceFlowText
              title="Supercharge your talent hiring. For our top tier clientele, we recommend this search option to achieve your toughest:"
              path={`dynamic1.${path}.text2`}
              locale={locale}
            />
          </span>
          <ul className="list-disc flex flex-col gap-2 sm:gap-[22px] pt-5 sm:pt-10 pl-5 pb-11">
            {care.map(({ id, label }) => (
              <li key={id}>{label}</li>
            ))}
          </ul>
          <div className="text-[#1B0D34] group w-max">
            <Link
              className="text-[#1B0D34] text-base sm:text-xl text-center pt-12 group group-hover:text-purple"
              href={localizePath("/newsroom", locale)}
            >
              <CustomSourceflowText
                path={`dynamic1.${path}.learnmore`}
                locale={locale}
                title={locale === "de" ? "Lerne mehr" : "Learn more"}
              />
              <span className="w-0 bg-purple h-[1px] transition-all block group-hover:w-full mt-[-8px]" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
